import Panel from './panel';

// View stack to handle view organisation.
class ViewStack {
	stack: Panel[];

	constructor() {
		this.stack = [];
	}

	public getCurrentView(): Panel {
		return this.stack[this.stack.length - 1];
	}

	public pushViewToStack(view: Panel | undefined, viewModel?: unknown): void {
		if (view) {
			view.model = viewModel;

			this.stack.push(view);
		}
	}

	public popCurrentView(): void {
		this.stack.pop();
	}
}

export default ViewStack;
